import {
  Chat,
  Comment,
  Image,
  Project,
  User,
  UserByUsernameDocument,
  UserByUsernameQuery,
  useReportContentMutation,
} from 'generated/graphql';

export type Content =
  | Pick<Comment, 'id' | '__typename' | 'isReported'>
  | Pick<Project, '__typename' | 'id' | 'isReported'>
  | Pick<User, '__typename' | 'id' | 'username' | 'haveIReported' | 'isReported'>
  | Image
  | Chat;

export const useReportContent = (content: Content) =>
  useReportContentMutation({
    notifyOnNetworkStatusChange: true,
    optimisticResponse: {
      __typename: 'Mutation',
      reportContent: {
        id: content.id,
        isReported: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        __typename: content.__typename,
      },
    },
    update: store => {
      const username = content.__typename === 'User' ? content.username : null;
      if (content && !username) {
        return;
      }

      try {
        const data = store.readQuery<UserByUsernameQuery>({
          query: UserByUsernameDocument,
          variables: { username },
        });

        if (data?.userByUsername) {
          data.userByUsername.haveIReported = true;
        }

        store.writeQuery({ query: UserByUsernameDocument, data, variables: { username } });
      } catch (e) {
        console.error(e);
      }
    },
  });
